export default __webpack_public_path__ + "static/features2-6b08b46ffc13d715a7fdb3c8a8eaac40.png";